import type { FaireProductEntity } from "../../entity_types/product";

export const p_bpkdepmc45: FaireProductEntity = {
  token: "p_bpkdepmc45",
  type: "product",
  name: "Furry Sheep - Organic Cotton Jacquard Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/15f099e7071ea1bb49f6b21d747ea3f778e1402986817d420e0d0dd791af8186.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af7868436618dd89076f02e4dd27d2ae8d7d95ad5cc01dcaa55a0918c17c66c7.jpeg",
    "https://cdn.faire.com/fastly/1a79bc641f5cee3428033bbc13b0870d93c305edbdf73b20df29f83202a02c3e.jpeg",
    "https://cdn.faire.com/fastly/2e4d6858cf3737c89830dbeef99eb497a3c9cc8e77f1d5619786aa713be2a15c.jpeg",
  ],
  priceDollars: 28,
  description:
    "Luxurious 100% organic cotton jacquard baby blanket featuring thick 'n' thin knitting with furry sheep motif design.\n\n• Large size - 30x42”\n• Ultra-Soft, lightweight, all-season, breathable, cozy and comfy.\n• Non-toxic & natural fabrication for sensitive skin, eco-friendly & sustainable materials used.\n• Made from sustainably grown organic cotton, supporting better livelihoods of small grower farmers.\n• Conscientiously designed in USA & ethically made by artisans at a GOTS certified facility in India.\n• Experience 'pure comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:30.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
